import { Link } from 'react-router-dom';
import { formatMoney, SAMPLE_BOX_DELIVERY_FEE } from '@hfb/shared';
import Logo from './Logo.jsx';
import { useCatalogConfig } from '../hooks/useCatalog.js';
import LegalLinks from './LegalLinks.jsx';

const COLUMNS = [
  {
    title: 'Shop',
    links: [
      { to: '/products', label: 'All boxes & add-ons' },
      { to: '/products?kind=box', label: 'Subscription boxes' },
      { to: '/products?kind=addon', label: 'One-off items' },
      // Use the shared constant so this never drifts from the real fee.
      { to: '/sample', label: `Sample box — ${formatMoney(SAMPLE_BOX_DELIVERY_FEE)}` },
    ],
  },
  {
    title: 'Account',
    links: [
      { to: '/login', label: 'Sign in' },
      { to: '/register', label: 'Create an account' },
      { to: '/app', label: 'My deliveries' },
      { to: '/app/orders', label: 'Order history' },
    ],
  },
];

export default function Footer() {
  const { data } = useCatalogConfig();
  const contact = {
    email: data?.business?.email || 'help@healthyfruitsbox.com',
    phone: data?.business?.phone || null,
  };
  return (
    <footer className="mt-24 bg-gradient-to-b from-leaf-900 to-[#0A2C18] text-milk">
      <div className="shell py-14">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <Logo tone="light" />
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-milk/70">
              Fruit cut to order and sprouts grown to their peak, delivered same-day across Kanpur.
              Hours fresh — never days.
            </p>
            {/* From Settings → Business, so a new number doesn't need a release. */}
            <p className="mt-6 text-sm text-milk/60">
              <a className="underline underline-offset-4" href={`mailto:${contact.email}`}>
                {contact.email}
              </a>
              {contact.phone && (
                <>
                  <span className="mx-2">·</span>
                  <a className="underline underline-offset-4" href={`tel:${contact.phone.replace(/\s/g, '')}`}>
                    {contact.phone}
                  </a>
                </>
              )}
            </p>
          </div>

          {COLUMNS.map((column) => (
            <div key={column.title}>
              <h3 className="text-2xs font-semibold uppercase tracking-[0.18em] text-leaf-300">
                {column.title}
              </h3>
              <ul className="mt-4 space-y-1">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="flex min-h-touch items-center text-sm text-milk/75 active:text-milk sm:hover:text-milk"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-2 border-t border-milk/15 pt-6 text-xs text-milk/50 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} HealthyFruitsBox. FSSAI licensed.</p>
          <LegalLinks tone="light" className="sm:justify-end" />
          <p>Cancel or pause any time — no lock-in, no cancellation fee.</p>
        </div>
      </div>
    </footer>
  );
}
